import { z } from 'zod';
import { DroneSchema, SampleMetaSchema } from './drone.js';

export const EmailSchema = z.string().email().max(254);
export const PasswordSchema = z.string().min(10).max(200);

export const SignupBody = z.object({ email: EmailSchema, password: PasswordSchema });
export const LoginBody = z.object({ email: EmailSchema, password: z.string().min(1).max(200) });
export const TokenBody = z.object({ token: z.string().min(20).max(200) });
export const ResetBody = z.object({ token: z.string().min(20).max(200), password: PasswordSchema });
export const ForgotBody = z.object({ email: EmailSchema });

export const UserDto = z.object({ id: z.string(), email: z.string(), createdAt: z.number() });
export type User = z.infer<typeof UserDto>;

export const SettingsSchema = z.object({
  tonicPc: z.number().int().min(0).max(11).default(1),
  scaleId: z.string().default('yaman'),
  ji: z.boolean().default(true),
  mode: z.enum(['play', 'continuous']).default('play'),
  assignment: z.enum(['single', 'ring', 'direction']).default('single'),
  droneIds: z.array(z.string()).default(['sa']),
  calm: z.boolean().default(false),
  theme: z.enum(['dark', 'light', 'system']).default('dark'),
  volume: z.number().min(0).max(1).default(0.8),
  /** verbose audio logging in the browser console */
  debugAudio: z.boolean().default(false),
  /** how sampled drones are re-pitched (A/B switch; see engine/types.ts PitchEngineMode) */
  pitchEngine: z.enum(['multisample', 'multisample-formant', 'resample', 'granular', 'live-stretch']).default('multisample'),
});
export type Settings = z.infer<typeof SettingsSchema>;

export const DroneRecordDto = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  drone: DroneSchema,
  isPublic: z.boolean(),
  slug: z.string().nullable(),
  plays: z.number(),
  forkedFrom: z.string().nullable(),
  authorName: z.string().nullable().optional(),
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type DroneRecord = z.infer<typeof DroneRecordDto>;

export const GalleryQuery = z.object({ sort: z.enum(['new', 'plays']).default('new'), cursor: z.string().optional(), limit: z.number().int().min(1).max(50).default(24) });
export const GalleryPage = z.object({ items: z.array(DroneRecordDto), nextCursor: z.string().nullable() });

export const SamplesListDto = z.object({ items: z.array(SampleMetaSchema) });
export const ErrorDto = z.object({ error: z.string(), message: z.string() });
